import { Flex, Loader as LemonadeLoader } from '@percent/lemonade'
import styles from './Loader.module.scss'

type LoaderProps = { isFullScreen?: boolean; isAuthLoader?: boolean }

export function Loader({ isFullScreen = false, isAuthLoader = false }: LoaderProps) {
  if (isAuthLoader)
    return (
      <Flex justify="center" className={isAuthLoader ? styles.authLoader : undefined}>
        <LemonadeLoader isFullScreen={isFullScreen} />
      </Flex>
    )

  return <LemonadeLoader isFullScreen={isFullScreen} />
}
